import { render, staticRenderFns } from "./MiscQuoteSideMenu.vue?vue&type=template&id=0bdce95d&scoped=true"
import script from "./MiscQuoteSideMenu.vue?vue&type=script&lang=js"
export * from "./MiscQuoteSideMenu.vue?vue&type=script&lang=js"
import style0 from "./MiscQuoteSideMenu.vue?vue&type=style&index=0&id=0bdce95d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdce95d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bdce95d')) {
      api.createRecord('0bdce95d', component.options)
    } else {
      api.reload('0bdce95d', component.options)
    }
    module.hot.accept("./MiscQuoteSideMenu.vue?vue&type=template&id=0bdce95d&scoped=true", function () {
      api.rerender('0bdce95d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/miscquote/MiscQuoteSideMenu.vue"
export default component.exports